import { render, staticRenderFns } from "./PropertyCardLoading.vue?vue&type=template&id=609b0193"
import script from "./PropertyCardLoading.vue?vue&type=script&lang=ts"
export * from "./PropertyCardLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports